import { useFormik } from 'formik';
import * as yup from 'yup';

const INITIAL_VALUES = {
  email: '',
  password: '',
  code: '',
  mfaSession: '',
  mfaSecret: '',
  mfaOtpUri: '',
  mfaUser: null,
  mfaEnrollmentSession: null,
  // Contexto de Parceiro escolhido para o cadastro de estação de trabalho,
  // preenchido pelo seletor de Parceiro quando aplicável.
  partnerContextId: null,
  // Lista de Parceiros elegíveis devolvida pelo sign-in barrado — só existe
  // com mais de um Parceiro, para alimentar o dropdown do seletor.
  partners: [],
  // Contexto de condomínio escolhido para o cadastro de estação de trabalho
  // (porteiro com vínculo de condomínio — fase 2), preenchido pelo seletor
  // de condomínio quando aplicável. Nunca coexiste com partnerContextId.
  condominiumContextId: null,
  // Lista de condomínios elegíveis devolvida pelo sign-in barrado — só existe
  // com mais de um condomínio, para alimentar o dropdown do seletor.
  condominiums: [],
};

// Senha obrigatória só no step `password`; código só nos steps de MFA.
function buildValidationSchema(currentStepKey) {
  const isMfaCodeStep =
    currentStepKey === 'mfaChallenge' || currentStepKey === 'mfaVerify';

  return yup.object({
    email: yup
      .string()
      .required()
      .email('email'),
    password: yup.string().when('email', email =>
      currentStepKey === 'password' && email
        ? yup
            .string()
            .min(4)
            .required()
        : yup.string(),
    ),
    code: isMfaCodeStep
      ? yup
          .string()
          .length(6)
          .required()
      : yup.string(),
  });
}

/**
 * Monta o Formik e roteia o submit por step.
 */
export default function useLoginForm({ currentStep, actions }) {
  const onSubmit = (values, helpers) => {
    switch (currentStep.key) {
      case 'email':
        return actions.emailValidation(values, helpers);
      case 'password':
        return actions.signIn(values, helpers);
      case 'forgot':
        return actions.forgot(values, helpers);
      case 'mfaChallenge':
        return actions.respondChallenge(values, helpers);
      case 'mfaVerify':
        return actions.confirmEnrollment(values, helpers);
      default:
        return null;
    }
  };

  return useFormik({
    initialValues: INITIAL_VALUES,
    validationSchema: buildValidationSchema(currentStep.key),
    onSubmit,
  });
}
